import { Skeleton } from "@/components/ui/skeleton";

export function SectionHeaderSkeleton() {
  return (
    <div className="mb-12 flex flex-col items-center text-center">
      <Skeleton className="mb-4 h-8 w-64" />
      <Skeleton className="mb-2 h-4 w-full max-w-2xl" />
      <Skeleton className="h-4 w-3/4 max-w-xl" />
    </div>
  );
}

export function CardSkeleton() {
  return (
    <div className="overflow-hidden rounded-lg bg-white shadow-md">
      <Skeleton className="aspect-video w-full rounded-none" />
      <div className="space-y-3 p-6">
        <Skeleton className="h-6 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
        <Skeleton className="h-4 w-2/3" />
        <Skeleton className="mt-4 h-9 w-full" />
      </div>
    </div>
  );
}

export function CardGridSkeleton({ count = 3 }: { count?: number }) {
  return (
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
      {Array.from({ length: count }).map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </div>
  );
}

interface SectionSkeletonProps {
  count?: number;
  className?: string;
  withButton?: boolean;
}

export function SectionSkeleton({
  count = 3,
  className = "py-12 md:py-16",
  withButton = true,
}: SectionSkeletonProps) {
  return (
    <section className={className}>
      <SectionHeaderSkeleton />
      <CardGridSkeleton count={count} />
      {withButton && (
        <div className="mt-12 flex justify-center">
          <Skeleton className="h-10 w-48 rounded-full" />
        </div>
      )}
    </section>
  );
}

export function FaqSkeleton() {
  return (
    <section className="py-12 md:py-16">
      <SectionHeaderSkeleton />
      <div className="mx-auto max-w-3xl space-y-3">
        {Array.from({ length: 5 }).map((_, i) => (
          <Skeleton key={i} className="h-14 w-full" />
        ))}
      </div>
      <div className="mt-12 flex justify-center">
        <Skeleton className="h-10 w-40 rounded-full" />
      </div>
    </section>
  );
}

export function QuizSkeleton() {
  return (
    <section className="my-8 rounded-3xl bg-blue-50 py-12 md:py-16">
      <SectionHeaderSkeleton />
      <div className="mx-auto max-w-2xl">
        <div className="flex flex-col items-center gap-4 rounded-lg bg-white p-6 shadow">
          <Skeleton className="h-24 w-24 rounded-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-2/3" />
          <Skeleton className="mt-2 h-10 w-32" />
        </div>
      </div>
    </section>
  );
}
